export default {
  '0': '日',
  '1': '月',
  '2': '火',
  '3': '水',
  '4': '木',
  '5': '金',
  '6': '土',
  '-1': '祝日',
  '-2': '祝前日',
}
